
interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">

          {/* Brand */}
          <div
            className="flex items-center space-x-2 cursor-pointer flex-shrink-0"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <img
              src="https://static.readdy.ai/image/3bf68d6c09283a962d249fcc9ea91526/ab1e605b7823c60e0472793f0d68ad5d.png"
              alt="BrightSync Logo"
              className="h-9 md:h-16 w-auto"
            />
            <span className="text-lg md:text-3xl font-bold text-[#1A2332] whitespace-nowrap">BrightSync</span>
          </div>

          {/* Desktop nav links */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('solution')}
              className="text-[#5A6670] hover:text-[#0A5F5C] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Solution
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-[#5A6670] hover:text-[#0A5F5C] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              How It Works
            </button>
            <button
              onClick={() => scrollToSection('pilot')}
              className="text-[#5A6670] hover:text-[#0A5F5C] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Pilot Program
            </button>
            <button
              onClick={() => scrollToSection('why-brightsync')}
              className="text-[#5A6670] hover:text-[#0A5F5C] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Why Us
            </button>
          </div>

          {/* Desktop CTA button */}
          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:flex bg-[#0A5F5C] text-white px-6 py-3 rounded-lg hover:bg-[#084A48] transition-all duration-300 font-medium items-center space-x-2 whitespace-nowrap cursor-pointer"
          >
            <span>Request Discussion</span>
            <i className="ri-arrow-right-line"></i>
          </button>

          {/* Mobile CTA button — compact */}
          <button
            onClick={() => scrollToSection('contact')}
            className="flex md:hidden bg-[#0A5F5C] text-white px-3 py-2 rounded-md text-xs font-semibold whitespace-nowrap cursor-pointer"
          >
            Request Discussion
          </button>

        </div>
      </div>
    </nav>
  );
}
